export default __webpack_public_path__ + "media/images/logo/media/tbs_radio-bb684aac3c4833ba649535fb39e1c0cf.png";